import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { Router, NavigationEnd } from '@angular/router';
import * as fromStore from '../../store';
import * as fromFeature from '../../my-features';
import { Store } from '@ngrx/store';
import { combineLatest, Subject } from 'rxjs';
import { SummaryService } from '../../services/summary.service';
import * as moment from 'moment';
import { eventMapping, PackageList, DeviceSubType } from '../../shareModel';
import { takeUntil } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-event-summary',
  templateUrl: './event-summary.component.html',
  styleUrls: ['./event-summary.component.css'],
})
export class EventSummaryComponent implements OnInit {

  cols: any[] = [
    { field: 'name', header: TRANSLATE('Device Name'), width: '200', class: 'col-nowrap', disabled: false },
    { field: 'time', header: TRANSLATE('Time'), width: '200', class: 'col-nowrap', disabled: true },
    { field: 'timezone', header: TRANSLATE('Time Zone'), width: '150', class: '', disabled: false },
    { field: 'desc', header: TRANSLATE('Description'), width: '450', class: 'col-nowrap', disabled: false }
  ];
  private componentDestroyed = new Subject();
  curDate = new Date();
  RangeParam = {
    otp: '',
    startDate: this.curDate.getTime() - 24 * 60 * 60 * 1000 * 7,
    endDate: 0,
    event: null,
    status: null,
    RegionIds: []
  };

  files1: any[];
  deviceOptions = [];
  selectedDevice: any;
  deviceSubtypeOptions = Object.values(DeviceSubType).filter(item => item.options).map(item => {
    return { label: item.name, value: item.value };
  });
  DeviceSubType: [];
  eventSummary: any;
  isMsp = false;

  constructor(private router: Router,
    private store: Store<fromStore.State>,
    private summaryService: SummaryService) {

    // Get Plan Account Info
    combineLatest([this.store.select(fromStore.getIsActiveUserModule, PackageList.EventSummary), this.store.select(fromStore.getIsMsp)])
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([res, msp]) => {
        const packageEventSummary = Boolean(res);
        if ((msp !== undefined && msp !== null && !msp) && (!packageEventSummary)) {
          this.goBack();
        }
      });

      if (this.summaryService.GetSummaryStartDate === 0 || this.summaryService.GetSummaryEndtDate === 0) {
        this.goBack();
      }
      const initialRangeParam = {
        ...this.RangeParam,
        event: this.summaryService.GetSummaryEvent !== null && this.summaryService.GetSummaryEvent !== undefined
          ? Number(this.summaryService.GetSummaryEvent)
          : this.RangeParam.event,
        status: this.summaryService.GetSummaryStatus !== null && this.summaryService.GetSummaryStatus !== undefined
          ? Number(this.summaryService.GetSummaryStatus)
          : this.RangeParam.status,
        startDate: Number(this.summaryService.GetSummaryStartDate.toString().substring(0, 10)),
        endDate: Number(this.summaryService.GetSummaryEndtDate.toString().substring(0, 10))
      };
      this.RangeParam = initialRangeParam;
      // 傳參數dispatch Event Store
      this.store.dispatch(new fromFeature.GetSummaryDetail({ ...this.RangeParam }));

    // 左上選單值有更新時
    this.store.select(fromStore.getMspRegionFilter).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      // this.mspSelectedRegionId = [];
      if (res !== undefined && res !== null && res.filterLoaded) {
        if (res.selectedId !== undefined && res.selectedId !== null && res.selectedId.length > 0) {
          this.RangeParam = {
            ...this.RangeParam,
            RegionIds: [...res.selectedId]
          };
          // 傳參數dispatch Event Store
          this.store.dispatch(new fromFeature.GetSummaryDetail({ ...this.RangeParam }));
          this.eventSummary = [];
          this.deviceOptions = [];
          this.deviceOptions.push({ label: 'Select Device', value: 'Select Device' });
        }
      }
    });
  }

  ngOnInit() {
    this.UI();
    // flag判斷是否為Init
    this.dispatchFilter(0, null, null);
  }

  UI() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-landing');
    body.classList.remove('body-login');
    body.classList.remove('mobile-toggle');
  }

  goBack(): void {
    this.router.navigate(['/dashboard']);
  }

  dispatchFilter(devicefilterflag , item, subtype) {
    const selectSubtype = (subtype && subtype.value) ? subtype.value : subtype;
    this.store.select(fromStore.getSummaryEvents).subscribe(res => {
      if (!res.Loading && res.Loaded) {
        const eventSummarydatalist = [];
        let allDevice = false;
        // 若為init就重畫filterOption
        if (devicefilterflag === 0) {
          this.deviceOptions = [];
          this.deviceOptions.push({ label: 'Select Device', value: 'Select Device' });
          this.selectedDevice = { label: 'Select Device', value: 'Select Device' };
        }
        if (res.entities != null && res.entities.length > 0) {
          const deviceName = (item && item.value) ? item.value : 'Select Device';
          let paramSubtype = [];
          if (selectSubtype && selectSubtype.length > 0) {
            paramSubtype = [...selectSubtype];
            const additionalMappings = {
              'ATS': 5,
              'PDU': 6
            };
            for (const [name, value] of Object.entries(additionalMappings)) {
              if (paramSubtype.some(id => DeviceSubType[id] && (DeviceSubType[id].name === name))) {
                if (!paramSubtype.includes(value)) {
                  paramSubtype.push(value);
                }
              } else {
                paramSubtype = paramSubtype.filter(i => i !== value);
              }
            }
          }
          res.entities.map(i => {
            if (Object.keys(i.event).length !== 0) {
              const eventlist = [];
              // 排序
              [...i.event].sort((a, b) => {
                return b.ts - a.ts;
              }).map(e => {
                // 判斷是否為init
                if (devicefilterflag !== 0) {
                  // 判斷filte Device
                  if (i['deviceName'].toLowerCase() === deviceName.toLowerCase()) {
                    allDevice = true;
                    eventlist.push({
                      name: i['deviceName'],
                      time: moment((Number(e.ts) * 1000) + (i.timeZone * 60 * 60 * 1000)).format('YYYY/MM/DD HH:mm:ss'),
                      timezone: Number(i.timeZone) >= 0 ? 'UTC+' + i.timeZone + ':00' : 'UTC' + i.timeZone + ':00',
                      desc: 'EventNumber_' + e.event_number,
                    });
                  } else if (deviceName === 'Select Device') {
                    // 如未選擇設備就List就Show全部
                    allDevice = true;
                    if (!paramSubtype || paramSubtype.length === 0 || paramSubtype.includes(i.DeviceSubType)) {
                      eventlist.push({
                        name: i['deviceName'],
                        time: moment((Number(e.ts) * 1000) + (i.timeZone * 60 * 60 * 1000)).format('YYYY/MM/DD HH:mm:ss'),
                        timezone: Number(i.timeZone) >= 0 ? 'UTC+' + i.timeZone + ':00' : 'UTC' + i.timeZone + ':00',
                        desc: 'EventNumber_' + e.event_number,
                      });
                    }
                  }
                } else {
                  // 取全部Device
                  // console.log(i);
                  if (!paramSubtype || paramSubtype.length === 0 || paramSubtype.includes(i.DeviceSubType)) {
                    eventlist.push({
                      name: i['deviceName'],
                      time: moment((Number(e.ts) * 1000) + (i.timeZone * 60 * 60 * 1000)).format('YYYY/MM/DD HH:mm:ss'),
                      timezone: Number(i.timeZone) >= 0 ? 'UTC+' + i.timeZone + ':00' : 'UTC' + i.timeZone + ':00',
                      desc: 'EventNumber_' + e.event_number,
                    });
                  }
                }
              });
              // DeviceList
              eventSummarydatalist.push(...eventlist);
              // 若為init就重畫filterOption
              if (devicefilterflag === 0) {
                if (!paramSubtype || paramSubtype.length === 0 || paramSubtype.includes(i.DeviceSubType)) {
                  this.deviceOptions.push({ label: i['deviceName'], value: i['deviceName'] });
                }
              }
            }
          });
        }
        this.eventSummary = eventSummarydatalist;
      }
    });
  }
}
